<nav class="modern-navbar">
  <div class="navbar-container">
    <!-- Brand Section -->
    <div class="navbar-brand-section">
      <button class="sidebar-toggle-btn" (click)="toggleSidebar()">
        <i class="fas fa-bars"></i>
      </button>
      <a class="navbar-brand" href="#/admin/dashboard">
        <div class="brand-logo">
          <img src="./assets/img/logo.png" alt="Digital Union Logo">
        </div>
        <div class="brand-text">
          <span class="brand-name">Digital Union</span>
          <span class="brand-subtitle">Management System</span>
        </div>
      </a>
    </div>

    <!-- Union Name Section -->
    <div class="navbar-union-section">
      <div class="union-info" *ngIf="!isLoadingUnion && unionData.union_name">
        <div class="union-name">
          <i class="fas fa-university"></i>
          <span class="union-name-text">{{ unionData.union_name }}</span>
        </div>
        <div class="union-details">
          <span class="upozilla">{{ unionData.upozilla_name }}</span>
          <span class="separator">•</span>
          <span class="zilla">{{ unionData.zilla_name }}</span>
        </div>
      </div>
      
      <!-- Loading state -->
      <div class="union-loading" *ngIf="isLoadingUnion">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </div>
      
      <!-- Fallback when no union data -->
      <div class="union-fallback" *ngIf="!isLoadingUnion && !unionData.union_name">
        <div class="union-name">
          <i class="fas fa-university"></i>
          <span class="union-name-text">Digital Union</span>
        </div>
        <div class="union-details">
          <span class="upozilla">Management System</span>
        </div>
      </div>
    </div>

    <!-- Right Actions -->
    <div class="navbar-actions">
      <!-- Profile Dropdown -->
      <div class="action-item profile-dropdown" ngbDropdown placement="bottom-right">
        <button 
          class="profile-btn" 
          ngbDropdownToggle
          id="profileDropdown"
          aria-label="Profile menu">
          <div class="profile-avatar">
            <i class="fas fa-user"></i>
          </div>
          <div class="profile-info">
            <span class="profile-name">{{ getUserDisplayName() }}</span>
            <span class="profile-role">{{ getUserRole() }}</span>
          </div>
        </button>
        
        <div ngbDropdownMenu aria-labelledby="profileDropdown" class="profile-menu">
          <h6 class="dropdown-header">Account</h6>
          <a class="dropdown-item" routerLink="/admin/profile-settings">
            <i class="fas fa-user-circle"></i>
            Profile Settings
          </a>
          <div class="dropdown-divider"></div>
          <button class="dropdown-item logout-btn" (click)="goToLoginPage()">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>